import { capitalizeString } from "../utils/stringModifications";

/** Known backend ingestion states used by the Historic NAR State column. */
export enum HistoricNarIngestionState {
  TOUCHLESS = "touchless",
  INGESTED_MANUAL = "ingested_manual",
  AGENTIC = "agentic",
  WATCHING = "watching",
  NEEDS_REVIEW = "needs_review",
  OTHER = "other",
}

/** Display labels and hex colors, including the neutral fallback palette. */
export const HistoricNarIngestionStateBadgesDetails = [
  {
    id: HistoricNarIngestionState.TOUCHLESS,
    label: "Touchless",
    bgColor: "#EAF2FF",
    textColor: "#0056D6",
  },
  {
    id: HistoricNarIngestionState.INGESTED_MANUAL,
    label: "Ingested Manual",
    bgColor: "#FFFCD6",
    textColor: "#665D00",
  },
  {
    id: HistoricNarIngestionState.AGENTIC,
    label: "Agentic",
    bgColor: "#FFF3E0",
    textColor: "#C24400",
  },
  {
    id: HistoricNarIngestionState.WATCHING,
    label: "Not Ingested",
    bgColor: "#F5F5F5",
    textColor: "#0F0F0F",
  },
  {
    id: HistoricNarIngestionState.NEEDS_REVIEW,
    label: "Needs Review",
    bgColor: "#FFE8E8",
    textColor: "#CC0300",
  },
  {
    id: HistoricNarIngestionState.OTHER,
    label: "Other",
    bgColor: "#F5F5F5",
    textColor: "#0F0F0F",
  },
];

/**
 * Return the matching badge for an exact state ID; watching displays as Not Ingested.
 * Unknown IDs retain the Other badge's ID and colors with a capitalized,
 * space-separated label (e.g. custom_state becomes Custom State).
 */
export const getHistoricNarIngestionStateBadge = (
  id: string,
): (typeof HistoricNarIngestionStateBadgesDetails)[number] => {
  const badge = HistoricNarIngestionStateBadgesDetails.find(
    (badge) => badge.id === id,
  );
  if (badge) return badge;

  // The palette always includes Other; copy it so fallback labels do not mutate it.
  const otherBadge = HistoricNarIngestionStateBadgesDetails.find(
    (badge) => badge.id === HistoricNarIngestionState.OTHER,
  )!;
  return {
    ...otherBadge,
    label: capitalizeString(id.replace(/_/g, " ")),
  };
};
